import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import FILTER_ITEMS from '../../utils/filterItems';  

const Filter = ({ handleFilterChange, filter }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const currentFilter = searchParams.get('filter');
    if (currentFilter) {
      const selectedFilter = FILTER_ITEMS.find( 
        item => item.url === currentFilter
      );
      if (selectedFilter && selectedFilter.url !== filter.url) {
        handleFilterChange(selectedFilter);
      }
    }
  }, [searchParams, filter, handleFilterChange]);

  const handleChange = e => {
    const selectedFilter = FILTER_ITEMS.find(
      item => item.url === e.target.value
    );
    if (selectedFilter) {
      handleFilterChange(selectedFilter);

      const params = new URLSearchParams(searchParams.toString());
      params.set('filter', selectedFilter.url); // Usar el valor en inglés para la URL
      params.set('page', '1'); // Reiniciar a la página 1
      setSearchParams(params);
    }
  };
  
  return (
    <div className="dropdown-search">
      <select
        id="filter-options"
        className="dropdown-search__select"
        value={filter.url}
        onChange={handleChange}
      >
        {FILTER_ITEMS.map((item, i) => (
          <option key={i} value={item.url}>
            {item.displayName} 
          </option>
        ))}
      </select>
    </div>
  );
};

export default Filter;
